export const appBaseURL = "/super-marui/030/"

export const appHead = {"meta":[{"charset":"utf-8"},{"content":"no-cache","http-equiv":"Cache-Control"},{"content":"no-cache","http-equiv":"Pragma"},{"content":"0","http-equiv":"Expires"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"http-equiv":"content-language","content":"ja"},{"hid":"description","name":"description","content":""},{"hid":"og:site_name","property":"og:site_name","content":"株式会社マルイのチラシ"},{"hid":"og:url","property":"og:url","content":"https://next.retailstudio.jp"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":" | 株式会社マルイ"},{"hid":"og:description","property":"og:description","content":""},{"hid":"og:image","property":"og:image","content":"https://next.retailstudio.jp/images/super-marui/ogp.png"},{"hid":"twitter:title","property":"twitter:title","content":" | 株式会社マルイ"},{"hid":"twitter:description","property":"twitter:description","content":""},{"hid":"twitter:image","property":"twitter:image","content":"https://next.retailstudio.jp/images/super-marui/ogp.png"},{"hid":"twitter:url","property":"twitter:url","content":"https://next.retailstudio.jp"},{"hid":"twitter:card","property":"twitter:card","content":"summary"}],"link":[{"rel":"icon","type":"image/png","href":"/super-marui/030/images/super-marui/favicon.ico","sizes":"any"},{"rel":"apple-touch-icon","href":"/super-marui/030/images/super-marui/apple-touch-icon.png","sizes":"360x360"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Rubik&family=Dancing+Script:wght@700&family=M+PLUS+Rounded+1c:wght@700&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Staatliches&display=swap"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"ja","translate":"no"}}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'